import { render, staticRenderFns } from "./WorkCompetitionDetail.vue?vue&type=template&id=3cd6705f"
import script from "./WorkCompetitionDetail.vue?vue&type=script&lang=js"
export * from "./WorkCompetitionDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkCompetitionDetail.vue?vue&type=style&index=0&id=3cd6705f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports